module.exports = __webpack_public_path__ + "img/round-keyboard_arrow_right-24px.297c56cc.svg";